/**
 * @file Determine things about an ad that are only known at placement
 *      time. This includes things told by us from the DSP (like dspName)
 *      and things we calculate ourselves (like orientation);
 */
import { getWindowSize } from 'shared/utils/dom';
import { parseQueryString } from './urls/misc';
/**
 * Get combined external and traffic-time contexts.
 */
export const getAdContext = () => (Object.assign(Object.assign({}, getPlacementContext()), getExternalContext()));
/**
 * Get context values that are only available when the ad is trafficked.
 */
const getPlacementContext = () => {
    const platform = detectPlatform();
    const size = getWindowSize();
    const url = window.location.href;
    return {
        orientation: getAdOrientation(size.width, size.height),
        // Traxex uses `mobile` instead of `mobileweb`.
        platform: platform === 'mobileweb' ? 'mobile' : platform || 'desktop',
        size: `${size.width}x${size.height}`,
        url,
    };
};
/**
 * Get any external tracking parameters. For iFramed ads, these are
 * passed through as query parameters. For inline/HTML5 ads, these
 * are attached to `window.ADAPT.externalContext`.
 */
const getExternalContext = () => {
    var _a, _b;
    return (Object.assign(Object.assign(Object.assign({}, (_a = window.ADAPT) === null || _a === void 0 ? void 0 : _a.externalContext), parseQueryString(window.location.href, true)), (_b = window.ADAPT) === null || _b === void 0 ? void 0 : _b.utmOverrides));
};
/**
 * Determines the ad orientation based on its current dimensions.
 */
export const getAdOrientation = (width, height) => height > width ? 'portrait' : 'landscape';
/**
 * Detects platform: Desktop, Mobile Web, or Native App
 */
export const detectPlatform = () => {
    if (window.mraid) {
        return 'app';
    }
    const w = window.$sf ? window.$sf.ext.geom().win.w : window.screen.width;
    return w < 768 ? 'mobileweb' : 'desktop';
};
